import React from 'react';
interface FormFieldProps {
  id: string;
  label: string;
  required?: boolean;
  error?: string;
  className?: string;
  children: React.ReactNode;
}
export function FormField({
  id,
  label,
  required = false,
  error,
  className = '',
  children
}: FormFieldProps) {
  return <div className={className} data-id="element-176" data-mp="15zo3dy0nf8xb">
      <label htmlFor={id} className="block text-xs font-bold uppercase tracking-[0.12em] text-muted" data-id="element-177" data-mp="160fuown7qkhs">
        {label}
        {required && <span className="text-flame" data-id="element-178" data-mp="22p5fauq85r7g"> *</span>}
      </label>
      <div className="mt-2" data-id="element-179" data-mp="1yo3dc64xb11s">{children}</div>
      {error && <p id={`${id}-error`} role="alert" className="mt-1.5 text-sm text-danger" data-id="element-180" data-mp="1yqpoefr0vyor">
          {error}
        </p>}
    </div>;
}